<template>
	<div class="contact-info">
		<div class="contact-content-wrapper">
			<t-timpex-icon
				type="bp"
				icon="person"
				size="xs"
				color="neutral"
			/>
			<span class="contact-content">
				<slot name="name">{{name}}</slot>
			</span>
		</div>
		<div class="contact-content-wrapper">
			<t-timpex-icon
				type="bp"
				icon="phone"
				size="xs"
				color="neutral"
			/>
			<span class="contact-content">
				<slot name="phone">{{phone}}</slot>
			</span>
		</div>
		<div class="contact-content-wrapper">
			<t-timpex-icon
				type="bp"
				icon="home"
				size="xs"
				color="neutral"
			/>
			<span class="contact-content">
				<slot name="company">{{company}}</slot>
			</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TContactInfo',
	props: {
		name: String,
		phone: String,
		company: String
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';

.contact-info {
	@extend %font-families-ui;
	display: grid;
	column-gap: 20px;
	grid-template-columns: repeat(3, minmax(min-content, max-content));
}

.contact-content-wrapper {
	display: flex;
	align-items: center;
}

.contact-content {
	@extend %text-small;
	font-weight: 600;
	margin-left: 10px;
	color: get-color($text, 'dark');
}
</style>

<docs>
```jsx
<div style="width:500px">
	<t-contact-info name="Arvid Jenssen" phone="99337712" company="Scan Vest Dekk AS"/>
</div>
```
</docs>